<div class="cl-line"></div>
<div class="cl-label">
    {{label}} <span *ngIf="required">*</span>
</div>

<textarea [ngClass]="{'cl-error': !isValid}" (change)="changed($event)" [(value)]="value" [rows]="rows" [cols]="cols" class="cl-textarea-input" type="text" #clinput>
</textarea>